module.exports = __webpack_public_path__ + "static/media/la_freccia_azzurra.aacbe77f.jpeg";